import type { MailboxSender } from '../lib/mailbox'
import { Pill } from './ui'

/**
 * Who the pane is showing details for, echoed back from the open email so it's clear
 * the panel is following the reading pane.
 *
 * Values here come from the message itself and are rendered as text only.
 */
export function SenderBanner({
    sender,
    subject,
    matched = false,
}: {
    sender: MailboxSender
    subject?: string
    matched?: boolean
}) {
    const showName = sender.displayName !== sender.emailAddress

    return (
        <div className="mb-2 rounded-md border border-action/20 bg-action/[0.07] px-2.5 py-2">
            <div className="flex items-center gap-1.5">
                <span className="truncate text-[11.5px] font-semibold">
                    {showName ? sender.displayName : sender.emailAddress}
                </span>
                {matched && <Pill tone="green">Matched</Pill>}
            </div>
            {showName && <div className="truncate text-[10.5px] text-foreground/55">{sender.emailAddress}</div>}
            {subject && (
                <div className="mt-0.5 truncate text-[11px] italic text-foreground/55">“{subject}”</div>
            )}
        </div>
    )
}
